export const SUBSCRIPTION_RENEWAL_NUDGE_TEST_IDS = {
    CONTAINER: "subscription-renewal-nudge-container",
    HEADER: "subscription-renewal-nudge-header",
    PLANS_CONTAINER: "subscription-renewal-nudge-plans-container",
    PLAN: "subscription-renewal-nudge-plan",
    PLAN_ADD_BUTTON: "subscription-renewal-nudge-plan-add-button",
    PLAN_PRICE: "subscription-renewal-nudge-plan-price",
    PLAN_REMOVE_BUTTON: "subscription-renewal-nudge-plan-remove-button",
} as const;

export const ADD_ICON_ASSETS = {
    ONE_BLACK: "portal/static-assets/images/subscriptions/blck-add.png",
    ONE: "portal/static-assets/images/subscriptions/one-add.png",
};

export const CONSTANTS = {
    ADD_ICON_ALT: "Add plan",
    PLANS_CONTAINER_ARIA_LABEL: "Available subscription plans",
};

export const ADD_ICON_DIMENSIONS = {
    WIDTH: 24,
    HEIGHT: 24,
};

export const PLAN_ICON_DIMENSIONS = {
    WIDTH: 14,
    HEIGHT: 14,
};






